import { render, staticRenderFns } from "./DepartmentTab.vue?vue&type=template&id=c858afa0&scoped=true&"
import script from "./DepartmentTab.vue?vue&type=script&lang=js&"
export * from "./DepartmentTab.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentTab.vue?vue&type=style&index=0&id=c858afa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c858afa0",
  null
  
)

export default component.exports